module.exports = __webpack_public_path__ + "static/media/figma.efb492c0.png";